module.exports = __webpack_public_path__ + "static/media/nasa-Q1p7bh3SHj8-unsplash_compr.b53e69f6.jpg";